import { useEffect, useState } from "react";

const PARTICLES = Array.from({ length: 28 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    size: Math.random() * 2.5 + 1,
    dx: (Math.random() - 0.5) * 120,
    duration: Math.random() * 14 + 10,
    delay: Math.random() * -20,
    opacity: Math.random() * 0.5 + 0.1,
    color: Math.random() > 0.5 ? "rgba(255,60,95,0.6)" : "rgba(108,63,255,0.6)",
}));

export default function PageNotFound() {
    const [path, setPath] = useState("/unknown-page");

    useEffect(() => {
        setPath(window.location.pathname || "/unknown-page");
    }, []);

    return (
        <>
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500&display=swap');

        .nf-root {
          background: #080810;
          color: #f0eeff;
          font-family: 'DM Sans', sans-serif;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          position: relative;
        }

        /* Grid */
        .nf-grid {
          position: fixed;
          inset: 0;
          background-image:
            linear-gradient(rgba(255,255,255,0.035) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.035) 1px, transparent 1px);
          background-size: 60px 60px;
          pointer-events: none;
          z-index: 0;
        }

        /* Orbs */
        .nf-orb {
          position: fixed;
          border-radius: 50%;
          filter: blur(120px);
          pointer-events: none;
          z-index: 0;
          animation: nf-drift 12s ease-in-out infinite alternate;
        }
        .nf-orb1 {
          width: 500px; height: 500px;
          background: radial-gradient(circle, rgba(108,63,255,0.25), transparent 70%);
          top: -100px; left: -100px;
        }
        .nf-orb2 {
          width: 400px; height: 400px;
          background: radial-gradient(circle, rgba(255,60,95,0.2), transparent 70%);
          bottom: -80px; right: -80px;
          animation-delay: -6s;
        }

        /* Scanlines */
        .nf-scanlines {
          position: fixed;
          inset: 0;
          background: repeating-linear-gradient(
            0deg, transparent, transparent 2px,
            rgba(0,0,0,0.06) 2px, rgba(0,0,0,0.06) 4px
          );
          pointer-events: none;
          z-index: 1;
        }

        /* Particles */
        .nf-particles {
          position: fixed;
          inset: 0;
          pointer-events: none;
          z-index: 1;
          overflow: hidden;
        }
        .nf-particle {
          position: absolute;
          border-radius: 50%;
          animation: nf-rise linear infinite;
        }

        /* Container */
        .nf-container {
          position: relative;
          z-index: 2;
          text-align: center;
          padding: 2rem;
          max-width: 700px;
        }

        /* Badge */
        .nf-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(255,60,95,0.12);
          border: 1px solid rgba(255,60,95,0.3);
          color: #ff3c5f;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 2.5px;
          text-transform: uppercase;
          padding: 7px 16px;
          border-radius: 100px;
          margin-bottom: 1.5rem;
          animation: nf-fadeUp 0.6s ease both;
        }
        .nf-badge-dot {
          width: 6px; height: 6px;
          background: #ff3c5f;
          border-radius: 50%;
          animation: nf-pulse 1.5s infinite;
        }

        /* Big 404 */
        .nf-big-number {
          font-family: 'Bebas Neue', sans-serif;
          font-size: clamp(140px, 22vw, 260px);
          line-height: 1;
          letter-spacing: -4px;
          position: relative;
          display: inline-block;
          color: transparent;
          -webkit-text-stroke: 2px rgba(255,255,255,0.08);
          user-select: none;
        }
        .nf-big-number::before {
          content: '404';
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, #ff3c5f, #6c3fff);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: nf-flicker 6s infinite;
        }
        .nf-big-number::after {
          content: '404';
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, #6c3fff, #ff3c5f);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          clip-path: polygon(0 40%, 100% 40%, 100% 55%, 0 55%);
          animation: nf-glitch 4s infinite;
        }

        /* Headline */
        .nf-headline {
          font-family: 'DM Sans', sans-serif;
          font-size: clamp(22px, 4vw, 32px);
          font-weight: 300;
          color: #f0eeff;
          margin-top: 1rem;
          letter-spacing: -0.5px;
          animation: nf-fadeUp 0.7s 0.15s ease both;
        }
        .nf-headline strong { font-weight: 500; }

        .nf-divider {
          width: 60px; height: 1px;
          background: linear-gradient(90deg, transparent, #ff3c5f, transparent);
          margin: 1.5rem auto;
        }

        .nf-sub {
          color: #6b6b8a;
          font-size: 15px;
          line-height: 1.7;
          max-width: 420px;
          margin: 0 auto 2.5rem;
          animation: nf-fadeUp 0.7s 0.25s ease both;
        }

        /* Buttons */
        .nf-actions {
          display: flex;
          gap: 14px;
          justify-content: center;
          flex-wrap: wrap;
          animation: nf-fadeUp 0.7s 0.35s ease both;
        }
        .nf-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 13px 28px;
          border-radius: 8px;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          text-decoration: none;
          border: none;
          transition: transform 0.2s, box-shadow 0.2s, background 0.2s;
        }
        .nf-btn-primary {
          background: linear-gradient(135deg, #ff3c5f, #d42850);
          color: #fff;
          box-shadow: 0 0 30px rgba(255,60,95,0.3);
        }
        .nf-btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 40px rgba(255,60,95,0.5);
        }
        .nf-btn-secondary {
          background: rgba(255,255,255,0.05);
          color: #f0eeff;
          border: 1px solid rgba(255,255,255,0.1);
          backdrop-filter: blur(10px);
        }
        .nf-btn-secondary:hover {
          transform: translateY(-2px);
          background: rgba(255,255,255,0.09);
          border-color: rgba(255,255,255,0.2);
        }

        /* URL display */
        .nf-url-display {
          margin-top: 3rem;
          font-size: 12px;
          color: #6b6b8a;
          letter-spacing: 0.5px;
          animation: nf-fadeUp 0.7s 0.45s ease both;
        }
        .nf-url-chip {
          display: inline-block;
          background: rgba(255,255,255,0.05);
          border: 1px solid rgba(255,255,255,0.08);
          padding: 5px 14px;
          border-radius: 6px;
          font-family: monospace;
          font-size: 12px;
          color: rgba(255,255,255,0.35);
          margin-top: 6px;
        }

        /* Keyframes */
        @keyframes nf-drift {
          from { transform: translate(0,0); }
          to   { transform: translate(40px,30px); }
        }
        @keyframes nf-fadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes nf-pulse {
          0%,100% { opacity:1; transform:scale(1); }
          50%      { opacity:0.4; transform:scale(0.6); }
        }
        @keyframes nf-glitch {
          0%,90%,100% { transform:translateX(0); opacity:0; }
          92%          { transform:translateX(-6px); opacity:0.7; }
          94%          { transform:translateX(6px); opacity:0.7; }
          96%          { transform:translateX(-3px); opacity:0.5; }
          98%          { transform:translateX(0); opacity:0; }
        }
        @keyframes nf-flicker {
          0%,96%,100% { opacity:1; }
          97%          { opacity:0.6; }
          98%          { opacity:1; }
          99%          { opacity:0.75; }
        }
        @keyframes nf-rise {
          from { transform: translateY(100vh) translateX(0); opacity:0; }
          10%  { opacity:1; }
          90%  { opacity:0.5; }
          to   { transform: translateY(-10vh) translateX(var(--dx)); opacity:0; }
        }
      `}</style>

            <div className="nf-root">
                <div className="nf-grid" />
                <div className="nf-orb nf-orb1" />
                <div className="nf-orb nf-orb2" />
                <div className="nf-scanlines" />

                {/* Particles */}
                <div className="nf-particles">
                    {PARTICLES.map((p) => (
                        <div
                            key={p.id}
                            className="nf-particle"
                            style={{
                                left: `${p.left}%`,
                                width: p.size,
                                height: p.size,
                                "--dx": `${p.dx}px`,
                                animationDuration: `${p.duration}s`,
                                animationDelay: `${p.delay}s`,
                                opacity: p.opacity,
                                background: p.color,
                            }}
                        />
                    ))}
                </div>

                <div className="nf-container">
                    {/* Badge */}
                    <div className="nf-badge">
                        <span className="nf-badge-dot" />
                        Error 404
                    </div>

                    {/* Big number */}
                    <div className="nf-big-number">404</div>

                    {/* Headline */}
                    <h1 className="nf-headline">
                        Page <strong>Not Found</strong>
                    </h1>
                    <div className="nf-divider" />
                    <p className="nf-sub">
                        The page you're looking for has drifted into the void. It may have
                        been moved, deleted, or never existed in the first place.
                    </p>

                    {/* Actions */}
                    <div className="nf-actions">
                        <a href="/" className="nf-btn nf-btn-primary">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                                <polyline points="9 22 9 12 15 12 15 22" />
                            </svg>
                            Back to Home
                        </a>
                        <button className="nf-btn nf-btn-secondary" onClick={() => window.history.back()}>
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="15 18 9 12 15 6" />
                            </svg>
                            Go Back
                        </button>
                    </div>

                    {/* URL chip */}
                    <div className="nf-url-display">
                        Requested path
                        <br />
                        <span className="nf-url-chip">{path}</span>
                    </div>
                </div>
            </div>
        </>
    );
}